<template>
	<div class="last">
		<div class="container">
			<span>版权所有：{{siteName}} |<a href="http://beian.miit.gov.cn"> {{icp}} </a></span>
		</div>
		
	</div>
</template>

<script>
	export default{
		nameL:"",
		components:{},
		data(){
			return{
				msg:'last',
				siteName:'广州蓝视顿电子有限公司',
				icp:'粤ICP备13017220号',
			}
		},
		methods:{
			getInfo(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getInfoApi,
					data: {}
				})
				.then((res) => {
					this.icp = res.data.data.icp;
					this.siteName = res.data.data.siteName;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getInfo();
		}
	}
</script>

<style lang="less" scoped="scoped">
@import url("../../styles/main.less");
.last{
	width: 100%;
	.height(60);
	background: #999;
	text-align: center;
	.line-height(60);
	.font-size(20);
	color: #000;
	a{
		color: #000;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/Last.vue